import { IAdmin, INote, IParticipant, IQuestionDB, IUsergroup, isNote, isQuestion } from '../../../types';

export interface  IStatusType  {
    id: number; 
    name: string;
}

export const statusses: IStatusType[] = [
    { id: 1, name: 'Nieuw' },
    { id: 2, name: 'Behandelen' },
    { id: 3, name: 'In behandeling' },
    { id: 4, name: 'Klaar voor publiceren' },
    { id: 5, name: 'Gepubliceerd' },
    { id: 6, name: 'Gearchiveerd' },                        
];

export const typeRoleAdmin=1;
export const typeRoleClerk=2;
export const typeRolePracticioner=3;
export const typeFactions=5;
export const statusNieuw=1;
export const statusBehandelen=2;
export const statusInBehandeling=3;
export const statusKlaarVoorPubliceren=4;
export const statusGepubliceerd=5;
export const statusGearchiveerd=6;

export function statussesallowed(statusses: IStatusType[], changeStatus: number, userId: string, userGroups: IUsergroup[]) { 
    var types = userGroups
                .qWhere((us: IUsergroup) => us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions)
                .qSelect((ug: IUsergroup) => ug.type);
    
    var allowedids: number[] = [];

    if (types.includes(typeRoleAdmin)) {
        return statusses;
    }

    if (types.includes(typeRolePracticioner)) {
        if (changeStatus === statusBehandelen || changeStatus === statusInBehandeling
        ) {
            if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);
            if (!allowedids.includes(statusInBehandeling)) allowedids.push(statusInBehandeling);
        }

        if ( changeStatus === statusInBehandeling || changeStatus === statusKlaarVoorPubliceren
        ) {            
            if (!allowedids.includes(statusInBehandeling)) allowedids.push(statusInBehandeling);            
            if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);
        }
    }
                     
    if (types.includes(typeRoleClerk)) {
        if (changeStatus === statusNieuw || changeStatus === statusBehandelen
        ) {
            if (!allowedids.includes(statusNieuw)) allowedids.push(statusNieuw);
            if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);            
        }    

        if (changeStatus === statusKlaarVoorPubliceren
        ) {
            if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);
            if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);
            if (!allowedids.includes(statusGepubliceerd)) allowedids.push(statusGepubliceerd);             
        }           

        if (changeStatus === statusGepubliceerd
        ) {
            if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);
            if (!allowedids.includes(statusGepubliceerd)) allowedids.push(statusGepubliceerd);             
        }       

    }
    if (types.includes(typeRoleClerk) || types.includes(typeRolePracticioner)) {
        if (!allowedids.includes(statusGearchiveerd)) allowedids.push(statusGearchiveerd);            
    }

    // Gewone gebruiker
    if (!allowedids.includes(changeStatus)) allowedids.push(changeStatus); 

    return statusses.qWhere((stat) => allowedids.includes(stat.id));
}

export function changestatussesallowed(statusses: IStatusType[], changeStatus: number, userId: string, userGroups: IUsergroup[]) { 
    var types = userGroups
                .qWhere((us: IUsergroup) => us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions)
                .qSelect((ug: IUsergroup) => ug.type);
    
    var allowedids: number[] = [];

    if (types.includes(typeRoleAdmin)) {
        return statusses;
    }

    if (types.includes(typeRolePracticioner)) {
        if (changeStatus === statusBehandelen 
        ) {
            if (!allowedids.includes(statusInBehandeling)) allowedids.push(statusInBehandeling);
        }

        if ( changeStatus === statusInBehandeling ) {            
            if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);
        }
    }
                     
    if (types.includes(typeRoleClerk)) {
        if (changeStatus === statusNieuw ) {
            if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);            
        }    

        if (changeStatus === statusKlaarVoorPubliceren ) {
            if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);
            if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);
            if (!allowedids.includes(statusGepubliceerd)) allowedids.push(statusGepubliceerd);             
        }       

    }
    if (types.includes(typeRoleClerk) || types.includes(typeRolePracticioner)) {
        if (!allowedids.includes(statusGearchiveerd)) allowedids.push(statusGearchiveerd);            
    }

    // Gewone gebruiker
    if (!allowedids.includes(changeStatus)) allowedids.push(changeStatus); 

    return statusses.qWhere((stat) => allowedids.includes(stat.id));
}

export function statussesallowedbatch(statusses: IStatusType[], 
                                      items: IQuestionDB[],
                                      userId: string, 
                                      userGroups: IUsergroup[]) {
    
    var allowedids: number[] = [];

    items.map((itm) =>
        changestatussesallowed(statusses, itm.status, userId, userGroups).map((itm) => {
                if (!allowedids.includes(itm.id)) allowedids.push(itm.id);}),
    );

    return statusses.qWhere((stat) => allowedids.includes(stat.id));
}

export function canAnswer(statusses: IStatusType[], changeStatus: number, userId: string, userGroups: IUsergroup[]) { 
    var types = userGroups
                .qWhere((us: IUsergroup) => us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions)
                .qSelect((ug: IUsergroup) => ug.type);
    
    if (types.includes(typeRolePracticioner)) {
        if (changeStatus === statusBehandelen) {
            return true;
        }

        if ( changeStatus === statusInBehandeling) {
            return true;
        }
    }

    return false;
}

export function showAnswer(status: number, userId: string, userGroups: IUsergroup[]) { 
    var types = userGroups
                .qWhere((us: IUsergroup) => us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions)
                .qSelect((ug: IUsergroup) => ug.type);
 
    if (types.includes(typeRolePracticioner) || types.includes(typeRoleClerk)) {
        if (status === statusBehandelen) {
            return true;
        }

        if ( status === statusInBehandeling) {
            return true;
        }

        if ( status === statusKlaarVoorPubliceren) {
            return true;
        }        
    }

    if (status === statusGepubliceerd) {
        return true;
    }   
}

export function showFaction(status: number, noteUserId: string, userId: string, userGroups: IUsergroup[]) { 
    var types = userGroups
                .qWhere((us: IUsergroup) => 
                    (us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions ||
                     us.userIDs.includes(noteUserId) && us.userIDs.includes(userId) && !!us.type && us.type === typeFactions),
                )
                .qSelect((ug: IUsergroup) => ug.type);

    if (types.includes(typeRoleAdmin) || types.includes(typeRolePracticioner) || types.includes(typeRoleClerk)) {
            return true;      
    }

    if (types.includes(typeFactions)) {
        return true;      
    }

    if (status === statusGepubliceerd) {
        return true;
    }   
    return false;
}

export function factionOfNote(item: INote,  userGroups: IUsergroup[]) {  
    var factionname ='';
    if (!!item && isNote(item) && isQuestion(item)) {
        var factionUserGroup = userGroups.qWhere((usg: IUsergroup) => 
            usg.userIDs && usg.userIDs.includes((item as INote).userId) &&
            usg.type===typeFactions) as IUsergroup[];  
        factionname=factionUserGroup&&factionUserGroup.length ?factionUserGroup.qFirst().name:'';
    }
    return factionname;
}

export function canChangeQuestion(statusses: IStatusType[], currStatus: number, userId: string, usergroups: IUsergroup[], admin: IAdmin) { 

    if (admin) {
        if (!admin.modquestion)
            return false;
    }

    var types = usergroups
                .qWhere((us: IUsergroup) => us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions)
                .qSelect((ug: IUsergroup) => ug.type);

    if (currStatus === statusNieuw) {
        return true;
    }

    if (types.includes(typeRoleAdmin)) {
        return true;
    }

    if (types.includes(typeRolePracticioner)) {
        if (currStatus === statusBehandelen || currStatus === statusInBehandeling ) {            
            return true;
        }
    }
                     
    if (types.includes(typeRoleClerk)) {
        if (currStatus === statusNieuw || currStatus === statusKlaarVoorPubliceren ) {
            return true;
        }       

    }

    return false;
}

export function canCreateQuestion(statusses: IStatusType[], userId: string, usergroups: IUsergroup[], admin: IAdmin) { 

    if (admin) {
        if (!admin.modquestion)
            return false;

        // like changing. if faction visible is enabled, then you cannot add a 
        // question unless you're part of the faction
        // like creating. if faction visible is enabled, then you cannot change a 
        // question unless you're part of the faction
        if (admin && admin.factionvisible) {
            if (usergroups.qAny((ug) => ug.userIDs.includes(userId) &&
                ug.type===typeFactions))
                return true;
        }
            
        if (!admin || admin && !admin.factionvisible)
            return true;
    }
    
    return false;
}

export function practicioners(allParticipants: IParticipant[], userGroups: IUsergroup[]) { 
    var practicionerIds = userGroups
                .qWhere((us: IUsergroup) => !!us.type && us.type === typeRolePracticioner)
                .qMapMany((ug: IUsergroup) => ug.userIDs);

    var practicioners: IParticipant[] = [];

    if (practicionerIds) {
        if (allParticipants) {
            practicioners = allParticipants.qWhere((us) => practicionerIds.includes(us.id));
        }
    }
   
    return practicioners;
}

export function getPracticioner(allParticipants: IParticipant[], practicionerId: string) { 

    if (practicionerId) {
        if (allParticipants) {
            var practicioner: IParticipant = allParticipants.qFirst((us) => us.id===practicionerId);
            if (practicioner) {
                return practicioner.name;
            }
        }
    }
   
    return '';
}

export function showPracticioner(status: number, userId: string, userGroups: IUsergroup[]) { 
    var types = userGroups
                .qWhere((us: IUsergroup) => 
                    (us.userIDs.includes(userId) && !!us.type && us.type === typeRolePracticioner),
                )
                .qSelect((ug: IUsergroup) => ug.type);

    if (types.includes(typeRolePracticioner)) {
        if (status === statusBehandelen) {
            return true;
        }

        if ( status === statusInBehandeling) {
            return true;
        }

        if ( status === statusKlaarVoorPubliceren) {
            return true;
        }    
    }
  
    return false;
}

export function showPracticionerViewModus(status: number) { 

    if (status === statusBehandelen) {
        return true;
    }

    if ( status === statusInBehandeling) {
        return true;
    }

    if ( status === statusKlaarVoorPubliceren) {
        return true;
    }    

    return false;
}

const maxStatus =6;

export function getStatusString(status?: number) {
    const statusses = [
        { id: 1, name: 'Nieuw' },
        { id: 2, name: 'Behandelen' },
        { id: 3, name: 'In behandeling' },
        { id: 4, name: 'Klaar voor publiceren' },
        { id: 5, name: 'Gepubliceerd' },
        { id: 6, name: 'Gearchiveerd' },                        
    ];
    if (!status || !statusses || status===undefined || (status<1 && status>maxStatus))
        return '';
    return statusses[status - 1].name;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/authmodule/authcheck.tsx